import React, {Component} from 'react';

class AllergiesInput extends Component {
	constructor() {
		super();

		this.state = {
			otherInputText: '',
            otherInputBlur: false,
            otherInputFocus: true,
            inputMade: false
		};

	}

	componentWillUnount() {
		this.setState({ inputMade: false });
	}

	handleOtherText(e) {
        e.stopPropagation();
        this.handleOtherFocus();
    }

	handleOtherFocus() {
		if (this.state.inputMade) this.props.removeItem({ index: 10, value: this.state.otherInputText });
        this.setState({otherInputFocus: true, otherInputBlur: false});
    }

    handleOtherInputBlur(e) {
        this.setState({otherInputFocus: false, otherInputBlur: true});
    }

    handleOtherInputChange(e) {
	    this.setState({
	        otherInputText: e.target.value
	    });
	}

    handleSubmit(e) {
    	this.props.addItem({ index: 10, value: this.state.otherInputText });
    	this.props.sendOtherInputValue({ index: 10, value: this.state.otherInputText });
        
    	e.stopPropagation();
    	this.handleOtherInputBlur();
    	this.setState({inputMade: true});
    }

	render() {


		return (
			<div className="allergies-other-input">
				{this.state.otherInputFocus &&
				<div className="other-input-confirm">
                    <input
                        type="text"
                        onClick={this.handleOtherText.bind(this)}
                        value={this.state.otherInputText}
                        onChange={this.handleOtherInputChange.bind(this)}
                        className="other-input"
                    />
                    <button type="button" className={ this.state.otherInputText ? "ha-btn-circle mr-1" : "ha-btn-circle mr-1 disabled" }  onClick={ this.handleSubmit.bind(this) }>
                    <i className="fa fa-check"/> 
                    </button>
                </div> } {(!this.state.otherInputFocus && this.state.otherInputBlur) && <span onClick={this.handleOtherText.bind(this)}>{this.state.otherInputText}</span>
            	}
			</div>
		)
	}


}

export default AllergiesInput;



// WEBPACK FOOTER //
// ./src/views/onboarding/AllergiesInput.js